import { useState, useEffect, RefObject, useCallback } from 'react';

function useContainerWidth(ref: RefObject<HTMLElement>): number | null {
  const [width, setWidth] = useState<number | null>(null);

  const handleResize = useCallback(() => {
    if (ref.current) {
      setWidth(ref.current.clientWidth);
    }
  }, [ref]);

  useEffect(() => {
    let rafId: number;

    const handleResizeOnRAF = () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
      rafId = requestAnimationFrame(handleResize);
    };

    window.addEventListener('resize', handleResizeOnRAF);
    handleResizeOnRAF();

    return () => {
      window.removeEventListener('resize', handleResizeOnRAF);
      cancelAnimationFrame(rafId);
    };
  }, [ref, handleResize]);

  return width;
}

export default useContainerWidth;
